// 2026-05-26 - FormuLearning - Step 3 §3.1 총 중량 입력
// 파일 위치: frontend/src/features/step3/TotalWeightSection.tsx

interface Props {
  value: number | null
  manual?: boolean
  onChange: (v: number) => void
}

export default function TotalWeightSection({ value, manual, onChange }: Props) {
  // 이슈 #15 F-4 Part 2 — RLD 중량에서 자동 채운 값이면 안내 배지를 표시한다(수동 편집 전까지).
  const autoFilled = !manual && value != null
  return (
    <div className="mb-4">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">
        Total Tablet Weight
      </h4>
      <div className="flex items-center gap-3 rounded border p-3" style={{ borderColor: 'var(--border-subtle)' }}>
        <label className="text-[11px] text-text-body">Total Weight:</label>
        <input
          type="number"
          value={value ?? ''}
          onChange={(e) => onChange(Number(e.target.value))}
          placeholder="e.g. 150"
          className="w-24 rounded bg-bg-input px-2 py-1 text-[11px] text-text-body outline-none focus:ring-1"
          style={{ borderColor: 'var(--border-soft)', border: '1px solid var(--border-soft)' }}
          min={0}
        />
        <span className="text-[11px] text-text-secondary">mg</span>
        {autoFilled && (
          <span
            className="rounded px-1.5 py-0.5 text-[9px] font-medium"
            style={{ backgroundColor: 'var(--bg-row-active)', color: 'var(--text-secondary)' }}
            title="Step 1에서 선택한 대조약 중량으로 자동 입력된 값입니다. 직접 수정하면 고정됩니다."
          >
            Auto from Reference Drug
          </span>
        )}
        <span className="ml-auto text-[10px] text-text-muted italic">Used to balance excipient % below</span>
      </div>
    </div>
  )
}
